import { metricsStatusOrder as sharedMetricsStatusOrder } from '@flowqa/shared';
import type { ExecutionStatusKey } from './metricsHelpers';
import type { MetricsPalette } from '@/shared/constants/metricsPalette';

export const metricsStatusOrder: ExecutionStatusKey[] = sharedMetricsStatusOrder;

export const metricsStatusMeta: Record<
  ExecutionStatusKey,
  { label: string; paletteKey: keyof MetricsPalette }
> = {
  passed: { label: 'Passed', paletteKey: 'pass' },
  failed: { label: 'Failed', paletteKey: 'fail' },
  skipped: { label: 'Skipped', paletteKey: 'skip' },
  errored: { label: 'Errored', paletteKey: 'error' },
  untested: { label: 'Untested', paletteKey: 'neutral' },
};

export const getMetricsStatusColor = (
  palette: MetricsPalette,
  status: ExecutionStatusKey,
): string => palette[metricsStatusMeta[status].paletteKey];

export const getMetricsStatusLabel = (status: ExecutionStatusKey): string =>
  metricsStatusMeta[status].label;
